import { app } from '../../../../app';
import { Controller } from './company-details.controller';
app.component('companySPAdminCompanyDetail', {
    bindings: {
        cmpDetail: '<',
        cmp: '<',
        cmpId: '<',
    },
    controller: Controller,
    templateUrl: require('./company-details.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/details/company-details.component.js